import React from 'react';
import Modal from '../../../Components/Modal';
import JobDetails from '../../../Components/Formatting/Grids/JobDetails';
import Button from '../../../Components/Button/Button';
import Callback from '../../../Services/Callback';
import ButtonRow from '../../../Components/Button/ButtonRow';
import { getEntityLink } from '../../../Services/helpers';
import Alert from '../../../Components/Alert';
import { useCalendarContext } from '../Provider';
import ButtonGap from '../../../Components/Button/ButtonGap';

const closer = new Callback();

const JobWithoutAppointment = ({job, onClose}) => {
    const {setSchedulingJob, schedulingJob} = useCalendarContext();

    if (!job) {
        return null;
    }

    return <Modal title="Job details" isOpen={!!job} setIsOpen={onClose} dismissible={!schedulingJob} closer={closer}>
        <Alert theme="info"
            title="Scheduled job"
            message={<>
                This job was scheduled without a time.<br />
                Use the 'Replan day' option to plan the best route for the day with an ETA for each job.
            </>}
        />

        <JobDetails job={job} customer={job.customer} />

        <ButtonRow>

            <Button theme="light"
                // icon="CalendarPen"
                label="Reschedule"
                onClick={() => setSchedulingJob(job)}
            />
            <Button theme="light"
                label="Customer"
                // icon="User"
                link={getEntityLink('Customers/Customer', job?.customerId)}
            />
            <ButtonGap />
            <Button theme="secondary" label="Close" onClick={() => closer.invoke()} />
        </ButtonRow>
    </Modal>
}

export default JobWithoutAppointment;
